<div>
  <h2>{{ 'ARC_SHARED_COMPONENTS_PRESENTATION_FORGOT_PASSWORD_LABEL' | translate }}</h2>

  <form class="p-grid p-nogutter" [formGroup]="forgotPasswordForm" (ngSubmit)="resetPassword()">
    <div class="p-col-12">
      <aur-input #email id="forgot-password-email-input" type="email" [autofocus]="true" formControlName="email"
        [label]="'ARC_SHARED_COMPONENTS_EMAIL_ADDRESS_LABEL' | translate" [errorMessages]="{
        'required': 'ARC_SHARED_COMPONENTS_PRESENTATION_FORGOTPASSWORD_VALID_EMAIL_REQUIRED' | translate,
        'email': 'ARC_SHARED_COMPONENTS_PRESENTATION_FORGOTPASSWORD_VALID_EMAIL_REQUIRED' | translate
      }"></aur-input>
    </div>
    <div class="p-col-12 reset-password-wrapper">
      <button id="btnResetPassword" type="submit" class="reset-button"
        aur-button>{{'ARC_SHARED_COMPONENTS_PRESENTATION_FORGOTPASSWORD_RESET_PASSWORD' | translate}}</button>
    </div>
  </form>

  <div class="p-col-12 ui-md-12 back-button-wrapper">
    <button aur-button id="btnGoBack" type="button" (click)="goBack()" importance="tertiary"
      icon="arrow_back">Back</button>

    <button id="btnGoToVerificationCode" aur-button type="button" importance="tertiary"
      (click)="goToVerificationCode()">{{ 'ARC_SHARED_COMPONENTS_PRESENTATION_FORGOTPASSWORD_ALREADY_HAVE_CODE' |
      translate }}
    </button>
  </div>
</div>
